import { DeductionsStoreType } from '@core/symbol';
import { OrderItem, OrderSideEnum } from '@libs/api-reference';
import { getOrderPrice } from './orderPrice';

const getConditionalOrderWage = (order: OrderItem, wage: DeductionsStoreType) =>
  order.orderSideId === OrderSideEnum.Buy
    ? 1 + wage.buyValue
    : 1 - wage.sellValue;

const getConditionalOrderValue = (
  order: OrderItem,
  wage: DeductionsStoreType,
  isDoneOrder: boolean
) =>
  isDoneOrder
    ? order.executedValue
    : order.quantity *
      getOrderPrice(order) *
      getConditionalOrderWage(order, wage);

const getConditionalOrderQuantity = (
  order: OrderItem,
  wage: DeductionsStoreType,
  isDoneOrder: boolean
) =>
  isDoneOrder
    ? order.executedQuantity
    : Math.ceil(
        (order.investValue || 0) /
          (getOrderPrice(order) * getConditionalOrderWage(order, wage))
      );

export {
  getConditionalOrderQuantity,
  getConditionalOrderValue,
  getConditionalOrderWage,
};
